import teamMember1 from "../assets/team/team-member-1.png";
import teamMember2 from "../assets/team/team-member-2.png";
import teamMember3 from "../assets/team/team-member-3.png";
import teamMember4 from "../assets/team/team-member-4.png";
import teamMember5 from "../assets/team/team-member-5.png";

const dentists = [
    {
        name: "Dr Pooja Lama",
        image: teamMember1,
        description: (
            <>
                <p>
                    <b>Hi, I’m Dr. Pooja Lama — and I’m here to support you every step of your dental journey.</b>
                </p>
                <p>
                    As the practice owner, my goal has always been simple: to create a space where you feel completely comfortable, listened to, and confident in the care you receive. 
                    I understand that visiting the dentist can sometimes feel overwhelming, which is why I’ve built this practice around compassion, transparency, and personalised care.
                </p>
                <p>
                    With over 25 years of experience in dentistry, I bring both clinical expertise and a gentle, patient-first approach to everything I do. I have a special interest in cosmetic dentistry, Invisalign,
                    and comprehensive family care, and I take great pride in helping patients achieve healthy, natural, and confident smiles.
                </p>
                <p>
                    Whether you’re visiting us for a routine check-up, addressing a concern, or considering a complete smile transformation, my team and I are here to guide you at every stage.
                    We take the time to listen, clearly explain your options, and ensure you feel comfortable and confident in every decision — because your peace of mind matters just as much as your smile.
                </p>
                <p>
                    At our practice, you’re not just a patient — you’re part of our community. If you ever have questions, concerns, or simply need reassurance, I’m always here to help.
                </p>
                <p>
                    Outside the clinic, I enjoy reading, experimenting with new recipes, spending time with my children, and exploring the outdoors.
                </p>
                <p>
                    Thank you for trusting us with your care — We  look forward to welcoming you. 
                </p>
            </>
        )
    },
    {
        name: "Dr Beverly San Pablo",
        image: teamMember2,
        description: (
            <>
                <p>
                    Dr Beverly San Pablo is one of the dentists looking after our patients in Newcastle. After graduating as a dentist in 2003, she has worked for 19 years as a general dentist. She is very keen with continuing her education here in Australia, and goes to the US for the same, never settling alone with what she has learnt from the university. She believes in evidence-based science and has a strong focus on prevention and conservation. Listening to every patient’s needs is very important to her.
                </p>
                <p>
                    With a smile on her face, she welcomes everybody.team
                </p>
                <p>
                    Outside the clinic, she loves spending time with her friends and enjoying good food with great stories.
                </p>

            </>
        )
    },
    {
        name: "Dr Nishita Sheth",
        image: teamMember3,
        description: (
            <>
                <p>
                    Dr Nishita Sheth holds a Doctor of Dental Medicine from the University of Sydney and is dedicated to delivering high-quality, patient-centred care. She is committed to creating a calm, welcoming environment where patients feel comfortable, informed, and well supported throughout their treatment.
                </p>
                <p>
                    Dr Nishita Sheth enjoys all aspects of general dentistry, with a particular focus on helping anxious patients feel at ease. She has a strong interest in preventative, restorative, and aesthetic dentistry, and believes in working collaboratively with patients to achieve healthy, functional, and long-lasting smiles.
                </p>
                <p>
                   Passionate about continuous learning, Dr Nishita Sheth regularly undertakes professional development to stay current with the latest advancements in dental care, ensuring her patients receive the highest standard of treatment.
                </p>
                <p>
                    Outside of dentistry, she enjoys cooking, reading, and maintaining an active lifestyle at the gym.
                </p>
            </>
        )
    },
    {
        name: "Dr Sushmita Karki",
        image: teamMember4,
        description: (
            <>
                <p>
                    Dr Sushmita Karki is a compassionate and dedicated dentist committed to helping patients achieve healthy, confident smiles. Her passion for dentistry began at a young age, inspired by witnessing her mother’s struggle with toothache, which motivated her to pursue a career focused on relieving pain and improving quality of life. She finds great fulfilment in seeing her patients leave the clinic feeling comfortable, cared for, and happy with their results.
                </p>
                <p>
                    Graduating in 2016, Dr Sushmita Karki has been practising dentistry with a strong focus on delivering high-quality, patient-centred care. She is committed to ongoing professional development and regularly undertakes further training to stay up to date with the latest advancements in modern dentistry.
                </p>
                <p>
                    Dr Sushmita Karki has a particular interest in surgical and aesthetic dentistry, and enjoys providing treatments that enhance both oral health and smile confidence. She is dedicated to creating a warm, welcoming environment where patients feel relaxed, informed, and supported throughout their dental journey.
                </p>
                <p>
                    Outside of dentistry, Dr Sushmita Karki enjoys travelling and exploring different cultures. She also values spending quality time with her family, including her young daughter and her beloved fur companion, Bella.
                </p>
            </>
        )
    }
];

const supportStaff = [
    {
        name: "Lashelle Reimer",
        image: teamMember5
    }
];


const teamMembers = { dentists, supportStaff };
export default teamMembers;
